import { CreateContextStateType, CreateContextValueType, RaffleDrawProviderProps } from '@src/lib/types/create-raffle-draw';
import { useInputHelper } from '@src/utils/inputs-helper';
import { generateCode } from '@src/utils/transform-helper';
import _ from 'lodash';

import React, { createContext, useContext } from 'react';
import { useService } from '../hooks';
import { useRaffleDrawContext } from '../provider';

const initialState: CreateContextStateType = {
  "code": "",
  "description": "",
  "name": "",
  "numWinners": "",
  "drawAt": null,
  "startAt": null,
  drawTime: null,
  "thumbnail": "",
  "ticketLimit": "",
  "ticketPrice": "",
  status: "INACTIVE",
  subject: "REGULAR",
} as CreateContextStateType

export const CreateContext = createContext<CreateContextValueType>({} as CreateContextValueType);

const CreateProvider = ({ children }: RaffleDrawProviderProps) => {
  const [error, setError ] = React.useState({});
  const { openCreate } = useRaffleDrawContext();
  const { state, onSetInitial, onDispatch, handleFormReset } = useInputHelper(initialState);
  const { onCreate, onRefresh } = useService();

  const onCreating = React.useCallback(() => {
    const Err: any = {};
    if(!state.description){
      Err.description = true
    }
    if(!state.thumbnail){
      Err.thumbnail = true
    }
    if(!state.startAt){
      Err.startAt = true
    }
    if(!state.ticketPrice){
      Err.ticketPrice = true
    }
    if(!state.drawAt){
      Err.drawAt = true
    }
    if(!state.ticketLimit){
      Err.ticketLimit = true
    }
    if(!state.drawTime){
      Err.drawTime = true
    }
    if(!state.numWinners){
      Err.numWinners = true
    }

    setError(Err);

    if(_.isEmpty(Err)){
      const params: any = {
        code: state.code,
        description: state.description,
        thumbnail: state.thumbnail,
        ticketPrice: state.ticketPrice,
        ticketLimit: state.ticketLimit,
        numWinners: state.numWinners,
        status: state.status,
        subject: state.subject,
        startDate: state.startAt.format('YYYY-MM-DD'),
        drawDate: state.drawAt.format('YYYY-MM-DD'),
        drawTime: state.drawTime.format('HH:mm')
      };

      onCreate.mutate(params,
        {
          onSuccess: () => {
            openCreate();
            onRefresh();
            onSetInitial(initialState);
          }
        }
      );
    }
  }, [state, onCreate, openCreate, onRefresh, onSetInitial]); // eslint-disable-line react-hooks/exhaustive-deps

  const value = {
    state,
    error,
    onDispatch,
    isLoading: onCreate.isPending,
    onCreating,
  };

  React.useEffect(() => {
    if(!_.isEmpty(error)){
      setError({});
    }
  },[state]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    onSetInitial({...initialState, code: generateCode()});

    return () => {
      handleFormReset();
    }
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CreateContext.Provider value={value}>
      {children}
    </CreateContext.Provider>
  );
};

export const useCreateContext = () => {
  return useContext(CreateContext);
}

export default CreateProvider;
